import PropTypes from 'prop-types';
import reactStringReplace from 'react-string-replace';
import HighlightedSuggestionText from './TypeaheadHighlightedSuggestionText';

const SuggestionSectionTitle = ({ searchText, title }) => {
  const escapedSearchText = searchText ? searchText.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') : '';
  const re = new RegExp(`(${escapedSearchText})`, 'i');
  return reactStringReplace(title, re, HighlightedSuggestionText);
};

SuggestionSectionTitle.propTypes = {
  searchText: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default SuggestionSectionTitle;
